import React from 'react';
import { bool, string } from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-scroll';

const Container = styled.li`
  display: inline;
  margin-left: 32px;

  &:hover {
    cursor: pointer;
  }
`;

const NavLink = styled(Link)`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
  text-align: center;
  text-decoration: none;
  color: #4a4a4a;
`;

const NavItem = ({ link, smooth, text }) => (
  <Container>
    <NavLink to={link} spy smooth={smooth} offset={-70} duration={500}>
      {text}
    </NavLink>
  </Container>
);

NavItem.propTypes = {
  link: string.isRequired,
  text: string.isRequired,
  smooth: bool,
};

NavItem.defaultProps = {
  smooth: false,
};

export default NavItem;
